export const APP_NAME = "Template";
export const BASE_URL = "http://192.241.129.103:4001/";
// "proxy": "http://192.241.129.103:4001/",
//     "homepage": "http://192.241.129.103:4002"
export const drawerWidth = 250;
export const BUSINESS = [
    {label: "Tour Operator", value: "Tour Operator"},
    {label: "Hotel", value: "Hotel"},
    {label: "Restaurant", value: "Restaurant"}
];